<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
  import { computed } from 'vue'
  import type { FieldConfig, FormData } from '@/types'
  import { getNestedValue } from '@/utils/formHelper'

  const props = defineProps<{
    field: FieldConfig,
    formData: FormData,
  }>()

  const emit = defineEmits<{
    (e: 'update-field', key: string, value: any): void,

  }>()

  const currentValue = computed(() => getNestedValue(props.formData, props.field.key))
</script>

<template>
  <div>
    <div class="flex flex-wrap gap-3 sm:gap-4 mt-2">
      <label
        v-for="option in field.options || []"
        :key="option.value"
        class="flex items-center gap-2 sm:gap-3 cursor-pointer">
        <div class="relative">
          <input
            :value="option.value"
            type="radio"
            class="absolute opacity-0 size-0 peer"
            :checked="currentValue === option.value"
            @input="emit('update-field', field.key, option.value)">
          <span class="border-2 border-gray-300 rounded-full size-5 flex items-center justify-center transition-all peer-checked:border-secondary-3 peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-primary-700/50">
            <span
              class="size-2.5 rounded-full transition-colors"
              :class="{ 'bg-primary-700': currentValue === option.value }"></span>
          </span>
        </div>
        <span class="text-gray-700 text-xs sm:text-sm 2xl:text-base">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

